var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRcIconAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.698 1.19C5.165 2.23 1.484 9.03 1.033 14.683c-.15 1.873.221 3.736.849 5.066.874 1.854 3.419 3.283 6.816 3.25 3.013-.029 6.21-1.345 8.98-2.843 3.119-1.687 5.622-3.729 5.293-6.772-.419-3.87-2.892-6.443-5.293-8.576C14.622 2.094 11.33.414 8.698 1.19z",
    fill: "#533633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14 14v-3.718h1.394L11.666 14H13l-2.418-4.032c1.173-.431 1.76-1.235 1.76-2.413C12.342 5.852 11.286 5 9.175 5H7v9h1.14zm.998-4.69H8.14V5.978h.969c.722 0 1.246.127 1.571.381.325.255.487.671.487 1.25 0 .591-.164 1.022-.493 1.293-.329.27-.84.406-1.535.406z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.035 19c.911 0 1.636-.326 2.173-.977.448-.542.712-1.212.792-2.012h-.893c-.092.5-.232.903-.42 1.21-.352.583-.867.874-1.542.874-.734 0-1.285-.277-1.655-.83-.37-.553-.555-1.275-.555-2.164 0-1.086.205-1.892.615-2.418.41-.525.947-.788 1.613-.788.547 0 .971.143 1.274.429.302.286.504.674.605 1.163h.894c-.053-.644-.315-1.22-.788-1.727-.473-.507-1.137-.76-1.994-.76-1.004 0-1.791.39-2.362 1.169-.528.717-.792 1.636-.792 2.756 0 1.476.351 2.567 1.054 3.273.535.535 1.195.802 1.98.802z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcIconAdmin);
export default __webpack_public_path__ + "static/media/rcIconAdmin.53257c4d.svg";
export { ForwardRef as ReactComponent };